import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Crosswalk } from '@kinetic-ui/data-layer';
import { useTranslation } from 'react-i18next';
import Dialog from 'components/Dialog';
import { RecursivePartial } from 'types/util';

export const ConfirmDeleteDialog: React.FunctionComponent<{
  crosswalk: RecursivePartial<Crosswalk> | undefined;
  setOpen: (open: boolean) => void;
  open: boolean;
  onDelete: (crosswalkId: string) => void;
}> = ({ crosswalk, setOpen, open, onDelete }) => {
  const { t } = useTranslation(['locations', 'common']);

  return (
    <Dialog
      open={open}
      title={`${t('locations:crosswalkDeleteConfirm')}`}
      buttons={
        <>
          <Button onClick={() => setOpen(false)}>{t('common:cancel')}</Button>
          <Button
            onClick={() => {
              setOpen(false);
              if (crosswalk?.id) {
                onDelete(crosswalk?.id);
              }
            }}
            variant='contained'
            color='warning'
          >
            {t('locations:deleteCrosswalk')}
          </Button>
        </>
      }
    >
      <Typography component='div'>
        <p>{t('common:deleteConfirm', { name: crosswalk?.description ?? '' })}</p>
        <p>{t('common:cantUndo')}</p>
      </Typography>
    </Dialog>
  );
};
